import { useEffect } from 'react';
import JSZip from 'jszip';
import { saveAs } from 'file-saver';

function useBulkDownloadAndZip(
  fileUrls?: Array<string>,
  zipFolderName = 'download',
  urlBasedFileNames?: boolean,
) {
  useEffect(() => {
    if (!fileUrls || !fileUrls?.length) return;
    const zip = new JSZip();

    const arrOfFiles = fileUrls.map((item, i) => {
      return fetch(item)
        .then((res) => res.blob())
        .then((resp) => {
          let name = `file-${i}`;
          if (urlBasedFileNames) {
            const ele = item.split('?')?.[0] || '';
            const eleLen = ele.split('/').length;
            name = ele.split('/')?.[eleLen - 1] || `file-${i}`;
          }
          zip.file(name, resp);
        });
    });
    Promise.all(arrOfFiles)
      .then(() => {
        zip.generateAsync({ type: 'blob' }).then(function (blob) {
          saveAs(blob, zipFolderName);
        });
      })
      .catch((err) => {
        console.log(err);
      });
  }, [fileUrls, zipFolderName]);
}

export default useBulkDownloadAndZip;
